module.exports = __webpack_public_path__ + "static/media/reviewTest.9bd518a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/helpDesk/videos/reviewTest.jpg
// module id = 1902
// module chunks = 0